import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";
import { saleOpeningEventCall } from "../../api/saleOpeningEvent";
import toast from "react-hot-toast";
import { useRef } from "react";
import SearchableSelect from "../../components/selectForm";
import iconExcel from "../../assets/images/timeKeeping/excel.svg";
import { importFile, importWithToast } from "../../utils/tools";

const columnMappingReverse = {
  "Mã căn": "code",
  "Giá tính phí dịch vụ": "priceForCommission",
  "Tỉ lệ TN sàn": "rateTNSan",
  "Số tiền TN sàn": "priceTNSan",
  "Tỉ lệ nhận về": "transactionRate",
};

export default function Step2({
  saleOpeningEventId,
  handleNext,
  handlePrevious,
}) {
  const inputFileRef = useRef(null);
  const [product, setProduct] = useState([]);
  const [fileName, setFileName] = useState("");
  const [typeValue, setTypeValue] = useState(0);

  const typeValues = [
    { key: 1, value: "Dấu phẩy" },
    { key: 2, value: "Dấu chấm" },
  ];

  const getProject = async (saleOpeningEventId) => {
    try {
      const data = await saleOpeningEventCall.getId(saleOpeningEventId);

      if (data?.apartmentSaleOpeningEventLink) {
        setProduct(data.apartmentSaleOpeningEventLink);
      }
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi lấy ra dự án");
    }
  };

  useEffect(() => {
    if (saleOpeningEventId) {
      getProject(saleOpeningEventId);
    }
  }, [saleOpeningEventId]);

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (fileExtension === "xlsx" || fileExtension === "csv") {
        setFileName(file.name);
      } else {
        alert("Vui lòng chọn file có định dạng .xlsx hoặc .csv");
        event.target.value = null;
        setFileName("");
      }
    }
  };

  // const handleImport = async () => {
  //   if (!inputFileRef.current || !inputFileRef.current.files[0]) {
  //     toast.error("Vui lòng chọn file để import.");
  //     return;
  //   }

  //   const fileEvent = { target: { files: inputFileRef.current.files } };
  //   const checkInColumnMappingReverse = columnMappingReverse;

  //   const toastCreate = toast.loading("Đang thêm danh sách...");
  //   try {
  //     await importFile(
  //       fileEvent,
  //       checkInColumnMappingReverse,
  //       typeValue,
  //       async (importedData) => {
  //         try {
  //           await saleOpeningEventCall.importCalculator(
  //             saleOpeningEventId,
  //             importedData
  //           );
  //           toast.success(`Xóa dữ liệu thành công`);
  //         } catch (error) {
  //           toast.error("API call failed");
  //           console.error("Lỗi khi bulkAdd:", error);
  //         }
  //       }
  //     );
  //   } catch (error) {
  //     toast.error("Import error");
  //     console.error("Lỗi khi importFile:", error);
  //   }
  //   toast.dismiss(toastCreate);
  // };

  const handleImport = async () => {
    if (!inputFileRef.current?.files?.[0]) {
      toast.error("Vui lòng chọn file để import.");
      return;
    }

    await importWithToast({
      files: inputFileRef.current.files,
      mapping: columnMappingReverse,
      typeValue,
      minLoadingMs: 400,
      toastMessages: {
        loading: "Đang import dữ liệu...",
        success: "Import dữ liệu thành công",
        error: "Import thất bại, vui lòng kiểm tra lại file.",
      },
      onData: async (importedData) => {
        // API call
        return await saleOpeningEventCall.importCalculator(
          saleOpeningEventId,
          importedData
        );
      },
      raw: false
    });
  };

  return (
    <Flex h={"calc(100vh - 254px)"} justifyContent={"center"}>
      <Flex gap={"20px"} flexDirection={"column"} w={"525px"}>
        <Text color={"var(--color-option-employee-hover)"}>
          (Dùng file được chuẩn bị ở bước 1, điền thông tin, chọn file và ấn import )
        </Text>
        <HStack spacing="4" w={"100%"}>
          <Input
            type="text"
            placeholder="Chưa có file nào được chọn"
            value={fileName}
            isReadOnly
            cursor="not-allowed"
            bg="gray.100"
            color="gray.800"
            _placeholder={{ color: "gray.500" }}
          />
          <Button
            as="label"
            htmlFor="file-upload"
            bg="blue.500"
            color="white"
            px="4"
            py="2"
            borderRadius="md"
            cursor="pointer"
            _hover={{ bg: "blue.600" }}
            _active={{ bg: "blue.700" }}
          >
            Chọn file
          </Button>
          <Input
            id="file-upload"
            type="file"
            accept=".xlsx, .csv"
            onChange={handleFileChange}
            ref={inputFileRef}
            display="none"
          />
        </HStack>
        <Box>
          <Text
            fontSize={{ base: "15px" }}
            fontWeight={500}
            lineHeight={"15px"}
            mb={"6px"}
            color={"var(--color-black-label)"}
          >
            Dấu phân cách
          </Text>
          <SearchableSelect
            isShowSearch={false}
            options={typeValues}
            initialSelectedOption={{
              key: 0,
              value:
                "Chọn dấu phân cách đơn vị thập phân của các loại giá hoặc %",
            }}
            setValue={setTypeValue}
            width="100%"
          />
        </Box>
        <Box>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{
              backgroundImage: "var(--color-button)",
            }}
            w={"100%"}
            onClick={handleImport}
          >
            <Image src={iconExcel} />
            <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
              Thêm giá tính phí dịch vụ và thưởng nóng sàn
            </Text>
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
}
